<template>
  <div class="flex-line" :class="{ 'border': showBorder }">
    <div class="left">
      <slot></slot>
    </div>
    <div class="right password-field">
      <slot name="right"></slot>
      <span v-if="isLink" class="iconfont arrow">&#xe650;</span>
      <span v-if="isPassword" class="password-toggle"
        :class="{ 'password-visible': showPassword, 'password-hidden': !showPassword }" @click="toggleVisibility"></span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'flexLine',
  data() {
    return {
    }
  },
  props: {
    toggleVisibility: {
      type: Function
    },
    showPassword: {
      type: Boolean,
      default: false
    },
    isPassword: {
      type: Boolean,
      default: false
    },
    isLink: {
      type: Boolean,
      default: false
    },
    showBorder: {
      type: Boolean,
      default: false
    }
  },
  methods: {
  }
}
</script>
<style scoped lang="scss">
.flex-line {
  display: flex;
  align-items: center;
  min-height: 2.5rem;
  background: #fff;

  &.border {
    border-bottom: 1px dashed #eee
  }

  .left {
    display: flex;
    align-items: center;
    flex: 1;
    font-size: $subFontSize;
    color: $formInputColor;
    font-weight: 700;

    .line-name {
      min-width: 4rem
    }
  }

  .right {
    display: flex;
    align-items: center;
    font-size: $subFontSize;
    color: $descTextColor;

    .arrow {
      font-size: $subFontSize;
    }
  }
}
</style>
